import { AxiosRequestConfig, AxiosResponseHeaders } from 'axios'
import { IBaseResponseData } from './index.js'

/**
 * This interface defines the object that is returned by the API when a request
 * is made to any endpoint. The `D` generic type is used to specify the type of
 * data that is expected to be returned from the API.
 *
 * The content of the response object is also determined by the value of the
 * `trimmedResponses` property of the app `config` object. If `trimmedResponses`
 * is set to **true** (the default value) then only the `data`, `status`, and
 * `statusText` properties of the response will be returned. If the value is set
 * to **false** then the entire `AxiosResponse` object is returned.
 */
export interface IResponse<D = IBaseResponseData> {
  //#region Required Properties
  data: D
  status: number
  statusText: string
  //#endregion Required Properties

  //#region Optional Properties
  config?: AxiosRequestConfig
  headers?: AxiosResponseHeaders
  request?: any
  //#endregion Optional Properties
}
